import { PhotoIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { getByTestId } from '../../../../lib/helper';
import Loader from '../../../Loader/Loader';
import StatusPill from '../../../StatusPill/StatusPill';
import { validTypeIcon } from './helper';
import { CardImagesProps } from './useCardImages';

const CardImages = ({
  imgSrc,
  imgBig,
  imgAlt,
  id,
  name,
  type,
  year,
  textOpen = 'Open',
  handleSearch,
  handleModal,
  testId,
}: CardImagesProps) => {
  const { t } = useTranslation();
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <div
      className={twMerge(
        'group relative',
        'h-[220px] justify-center',
        'p-3 items-center flex',
      )}
      {...getByTestId(testId, 'container')}
    >
      {year && (
        <StatusPill
          text={year}
          title={t('Card.Year', { year })}
          additionalClasses={twMerge(
            'absolute z-30 top-[-5px] left-[50%]',
            'ml-[-30px] px-2 w-[60px] border-gray-100',
            'border-0 rounded-b-lg rounded-t-none ',
            'bg-tahiti-100  ',
          )}
          {...getByTestId(testId, 'year')}
        />
      )}

      {id && (
        <StatusPill
          text={id}
          title={t('Card.ID', { id })}
          additionalClasses={twMerge(
            'absolute z-30 top-0 left-0 bg-white border border-gray',
          )}
          {...getByTestId(testId, 'id')}
        />
      )}

      {type && (
        <StatusPill
          text={validTypeIcon(type)}
          title={t('Card.Type', { type })}
          onClick={() => handleSearch?.(type, 'type')}
          additionalClasses={twMerge(
            'absolute cursor-pointer',
            'hover:opacity-80 z-30 top-1 right-1',
          )}
          {...getByTestId(testId, 'type')}
        />
      )}

      {imgBig && (
        <div
          className={twMerge(
            'bg-black w-full h-full absolute z-10',
            'justify-center items-center flex text-white flex-col',
            'opacity-0 hover:opacity-50 cursor-pointer',
          )}
          onClick={() => handleModal?.({ imgBig, imgAlt, name })}
        >
          <PhotoIcon className="w-6 h-6 text-white" />
          {textOpen}
        </div>
      )}

      {!imgLoaded && <Loader testId={`${testId}-loader`} />}

      <img
        className={twMerge('rounded-xl max-w-[200px]', !imgLoaded && 'hidden')}
        src={imgSrc}
        alt={imgAlt}
        onLoad={() => setImgLoaded(true)}
        {...getByTestId(testId, 'images')}
      />
    </div>
  );
};

export default CardImages;
